import React from 'react'
import { useEffect , useState} from 'react';
import {Container , Grow , Grid} from '@material-ui/core';
import Posts from '../posts/posts';
import Form from '../form/form';
import {getPosts} from '../../actions/posts'
import { useDispatch } from 'react-redux';
const Home = () => {
    const [currentId, setCurrentId] = useState(null);
    
    const dispatch = useDispatch(getPosts());
    useEffect(()=>{
    dispatch(getPosts());
 
    } , [currentId,  dispatch])
    return (
        <Grow in>
        <Container>
          <Grid container  justifyContent="space-between" alignItems="stretch" spacing={3}>
            <Grid item xs={12} sm={7}>
              <Posts setCurrentId={setCurrentId} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Form currentId={currentId} setCurrentId={setCurrentId}/>
            </Grid>
          </Grid>
        </Container>
      </Grow>
    )
}

export default Home;
